import styled from 'styled-components';
import {Span} from './body';
import PropTypes from 'prop-types';
import {grey} from 'components/primitives/color';


export const Caption = styled(Span)`
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    line-height: 14px;
    color: ${({sub}) => sub ? grey.grey400 : grey.grey000};
`;
Caption.displayName = 'Caption';
Caption.propTypes = {
    sub: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export const Overline = styled(Caption)`
    text-transform: uppercase;
`;
Overline.displayName = 'DisplayName';
Overline.propTypes = {
    sub: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
